import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';

const SubMapType = (props) => {
    return (
        <MenuItem sx={{ height: '25px', paddingLeft: '20px', fontSize: '12px' }} onClick={props.onClick}>
            <Checkbox
                color="default"
                checked={props.checked}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            { props.children }
        </MenuItem>
    );
};

SubMapType.propTypes = {
    onClick: PropTypes.func,
    checked: PropTypes.bool,
};

export default SubMapType;
